import React from 'react'
import './input-error-messege.scss'

export default ({ message }) => {
  if (message) return (
    <small className='input-error-message'>*{message}</small>
  )
  return <></>
}